import ActionsDirective from '../ActionsDirective';
import Title from '../Title';
import type { NodeBase } from '../../../../entities/Node';
import { HoverActions } from '../../HoverActions/HoverActions';
import { useHoverActions } from '../../HoverActions/useHoverActions';

const Catalog = ({ node }: { node: NodeBase }) => {
  const { title } = node;
  const showHoverActions = useHoverActions(node);

  return (
    <ActionsDirective node={node}>
      <div className="u-flex">
        <Title title={title} />
      </div>
      {showHoverActions && <HoverActions node={node} />}
    </ActionsDirective>
  );
};

export default Catalog;
